import { render, staticRenderFns } from "./MsgContent.vue?vue&type=template&id=b2d4bbc8"
import script from "./MsgContent.vue?vue&type=script&lang=js"
export * from "./MsgContent.vue?vue&type=script&lang=js"
import style0 from "./MsgContent.vue?vue&type=style&index=0&id=b2d4bbc8&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2d4bbc8')) {
      api.createRecord('b2d4bbc8', component.options)
    } else {
      api.reload('b2d4bbc8', component.options)
    }
    module.hot.accept("./MsgContent.vue?vue&type=template&id=b2d4bbc8", function () {
      api.rerender('b2d4bbc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/MsgContent.vue"
export default component.exports